(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lt-card-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lt-card-colors')) {
  class LtCardColors extends HTMLElement {
    connectedCallback() {
      this.savedImages = new Map();
      this.showPreview = (event) => {
        if (event.pointerType === 'touch') return;
        const swatch = event.target.closest('.lt-card-swatch');
        if (!swatch || !this.contains(swatch) || !swatch.dataset.ltPreviewSrc) return;
        const card = this.closest('product-card, .lt-stock__card');
        if (!card) return;
        this.previewCard = card;
        const images = card.querySelectorAll('.lt-stock__media img, .card-gallery img');
        for (const image of images) {
          if (!this.savedImages.has(image)) {
            this.savedImages.set(image, {
              src: image.getAttribute('src'),
              srcset: image.getAttribute('srcset'),
              sizes: image.getAttribute('sizes'),
              alt: image.getAttribute('alt')
            });
          }
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.setAttribute('src', swatch.dataset.ltPreviewSrc);
          image.setAttribute('alt', swatch.dataset.ltPreviewAlt || '');
        }
        card.dataset.ltPreviewColor = swatch.dataset.ltColor;
      };
      this.leavePreview = (event) => {
        if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;
        if (this.matches(':hover') || this.contains(document.activeElement)) return;
        this.resetPreview();
      };
      this.addEventListener('pointerover', this.showPreview);
      this.addEventListener('focusin', this.showPreview);
      this.addEventListener('pointerleave', this.leavePreview);
      this.addEventListener('focusout', this.leavePreview);
    }
    resetPreview() {
      for (const [image, attributes] of this.savedImages || []) {
        for (const [name, value] of Object.entries(attributes)) {
          if (value === null) image.removeAttribute(name);
          else image.setAttribute(name, value);
        }
      }
      this.savedImages?.clear();
      if (this.previewCard) delete this.previewCard.dataset.ltPreviewColor;
    }
    disconnectedCallback() {
      this.resetPreview();
      this.removeEventListener('pointerover', this.showPreview);
      this.removeEventListener('focusin', this.showPreview);
      this.removeEventListener('pointerleave', this.leavePreview);
      this.removeEventListener('focusout', this.leavePreview);
    }
  }
  customElements.define('lt-card-colors', LtCardColors);
}
  } catch(e) { console.error(e); }
})();

})();
